import { Link } from "react-router-dom";

type ButtonLinkProps = {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outline" | "gold";
  className?: string;
  onClick?: () => void;
  openInNewTab?: boolean;
};

function isExternalHref(href: string) {
  return href.startsWith("http://") || href.startsWith("https://") || href.startsWith("mailto:") || href.startsWith("tel:");
}

export function ButtonLink({ href, children, variant = "primary", className = "", onClick, openInNewTab }: ButtonLinkProps) {
  const classes = `button button-${variant} ${className}`.trim();

  if (isExternalHref(href)) {
    const shouldOpenNewTab = openInNewTab ?? (href.startsWith("http://") || href.startsWith("https://"));
    return (
      <a className={classes} href={href} onClick={onClick} target={shouldOpenNewTab ? "_blank" : undefined} rel={shouldOpenNewTab ? "noreferrer" : undefined}>
        {children}
      </a>
    );
  }

  return (
    <Link className={classes} to={href} onClick={onClick}>
      {children}
    </Link>
  );
}
